export default __webpack_public_path__ + "static/media/FM.4d32119b.jpg";